export function spendingDemandReducer(state = {
    ADMIN: {},
    USER: {},
},{
    type,
    payload
}){
    
    switch(type){
        case "NEW_SPENDING_DEMAND":            
            let list = Object.assign({}, state);
            list.USER[payload.spending_demand_id] = payload
            list.ADMIN[payload.spending_demand_id] = payload
            
            return list
        case "UPDATE_SPENDING_DEMAND":            
        case "UPDATE_FETCH_SPENDING_DEMAND":            
            let list2 = {}
            list2.ADMIN = Object.assign({}, state.ADMIN);
            list2.USER = Object.assign({}, state.USER);
            const {userID, data} = payload;
            
            if(userID === data.spending_demand_user){
                list2.USER[data.spending_demand_id] = data
            }

            list2.ADMIN[data.spending_demand_id] = data
            
            return list2
            
        case "DELETE_SPENDING_DEMAND":            
            let list5 = Object.assign({}, state);
            
            if(payload.userID === payload.data.spending_demand_user){
                delete list5.USER[payload.data.spending_demand_id]
            }

            delete list5.ADMIN[payload.data.spending_demand_id]
            
            return list5
            
        case "GET_USER_SPENDING_DEMANDS":
            let list3 = Object.assign({}, state);
            list3.USER = payload
            return list3

        case "GET_ADMIN_SPENDING_DEMANDS":
            let list4 = Object.assign({}, state);
            list4.ADMIN = payload
            return list4
            
        case "GET_SPENDING_DEMAND_PAYMENTS":          
            let list6 = Object.assign({}, state);
            list6.ADMIN[payload.spendingID].spending_demand_payments = payload.payments
            return list6
        case "ADD_SPENDING_DEMAND_TO_PROJECT":          
            let list7 = Object.assign({}, state);
            payload.list.forEach(spending => {
                let tab = list7.ADMIN[spending].spending_demand_project.split()
                if ( !tab.includes(payload.project_demand_id)) {
                    tab.push(payload.project_demand_id)
                }
                list7.ADMIN[spending].spending_demand_project = tab.join(", ")
            });
            return list7

        default:
            return state;
    }
    
}